/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import ReactSelect from 'components/Fields/ReactSelect';
import { Field } from 'formik';
import { CITY_BY_STATE } from 'pages/MarketListing/MarketListingGraphQL';
import Loader from 'components/common/Loader';

const CityField = ({ name, label, id, stateId, required = false, ...rest }) => {
  const [citiesByState, { data, loading, error }] = useLazyQuery(
    CITY_BY_STATE,
    {
      fetchPolicy: 'network-only',
    },
  );

  useEffect(() => {
    if (stateId)
      citiesByState({
        variables: {
          state: stateId,
          // country: countryId,
        },
      });
  }, [stateId]);

  if (loading) return <Loader size="sm" />;
  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <div>
      <Field
        id={id}
        label={label}
        name={name}
        type="select"
        component={ReactSelect}
        data={data?.citiesByState || []}
        keys={{ id: 'id', label: 'label' }}
        getOptionValue={(option) => option.id}
        getOptionLabel={(option) => option.cityName}
        required={required}
        {...rest}
      />
    </div>
  );
};

export default CityField;
